function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import httpOptions from './httpOptions';
import isJSONResponse from './isJSONResponse';
import isHTMLResponse from './isHTMLResponse';
import { getFromCache, getCacheKey, addToCache } from './response-cache';
function multiFetch(urls, options) {
  // @ts-ignore
  return Promise.all(
  // @ts-ignore
  urls.map(function (url) {
    if (Array.isArray(url)) {
      return fetcher(url, options);
    }
    return singleFetch(url, options);
  }));
}
function tryJson(res) {
  try {
    return res.json().then(function (data) {
      res.data = data;
      return res;
    });
  } catch (err) {
    console.log('Error parsing response as JSON', err);
    return tryText(res);
  }
}
function tryText(res) {
  try {
    return res.text().then(function (data) {
      res.data = data;
      return res;
    });
  } catch (err) {
    console.log('Error parsing response as text', err);
    return res;
  }
}
function handleResponse(res) {
  var resType = res.headers.get('Content-Type');
  var hasContent = res.headers.get('Content-Length') !== '0';
  if (hasContent && isJSONResponse(resType)) {
    return tryJson(res);
  } else if (hasContent && isHTMLResponse(resType)) {
    return tryText(res);
  } else {
    return res;
  }
}
function handleBadResponse(res) {
  console.log('Error caught in @dm/utils while fetching, you should handle this with a catch', res);
  throw res;
}
function singleFetch(url, options) {
  var cacheKey = getCacheKey(url, options.method);
  var cachedResponse = getFromCache(cacheKey);
  var _options$simpleCache = options.simpleCache,
    simpleCache = _options$simpleCache === void 0 ? false : _options$simpleCache,
    opts = _objectWithoutProperties(options, ["simpleCache"]);
  if (simpleCache && cachedResponse) {
    // @todo maybe make this a cloned response?
    return Promise.resolve({
      data: cachedResponse,
      fromCache: true
    });
  } else {
    return window.fetch(url, opts).then(handleResponse).then(function (res) {
      if (res.ok) {
        if (simpleCache) {
          addToCache(cacheKey, res.data);
        }
        return res;
      } else {
        return handleBadResponse(res);
      }
    });
  }
}
export default function fetcher(urls) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var opts = httpOptions.getOptions(options);
  return Array.isArray(urls) ? multiFetch(urls, opts) : singleFetch(urls, opts);
}